import React, { ElementType, ReactNode } from 'react'

function cx(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ')
}

interface CardProps {
  as?: ElementType;
  className?: string;
  children?: ReactNode;
  [key: string]: unknown;
}

export default function Card({ as: Component = 'div', className = '', children, ...props }: CardProps) {
  return (
    <Component
      className={cx('rounded-2xl bg-shell shadow-soft p-6', className)}
      {...props}
    >
      {children}
    </Component>
  )
}
